// extracted by mini-css-extract-plugin
module.exports = {"ProfilePage":"ProfilePage_ProfilePage__12swl","EditButton":"ProfilePage_EditButton__1DqDx"};